import { createAction } from "../../core/AppUtils";
import {
  AdminStudentRepository,
  CommonRepository,
} from "../../core/repository";

export const ModuleEvents = {
  GET_ADMIN_STUDENT_LIST: "GET_ADMIN_STUDENT_LIST",
  CREATE_ADMIN_STUDENT: "CREATE_ADMIN_STUDENT",
  CREATE_ADMIN_STUDENT_BY_COURSE: "CREATE_ADMIN_STUDENT_BY_COURSE",
  UPDATE_STUDENT_STATUS: "UPDATE_STUDENT_STATUS",
  GET_COURSE_LIST: "GET_COURSE_LIST",
  GET_STUDENT_PROGRESS: "GET_STUDENT_PROGRESS",
  GET_STUDENT_ATTEMPTDETAILS: "GET_STUDENT_ATTEMPTDETAILS",
  GET_ADMIN_STUDENT_COURSEDETAILS: "GET_ADMIN_STUDENT_COURSEDETAILS",
  GET_ALL_ADMIN_STUDENT_LIST: "GET_ALL_ADMIN_STUDENT_LIST",
  RESET_COURSE_PROGRESS: "RESET_COURSE_PROGRESS",
  FETCH_STUDENT_BY_ID: "FETCH_STUDENT_BY_ID",
  UPDATE_STUDENT: "UPDATE_STUDENT",
  DELETE_STUDENT_REVIEWS: "DELETE_STUDENT_REVIEWS",
  UPDATE_STUDENT_ENROLLMENT: "UPDATE_STUDENT_ENROLLMENT",
};

export default {
  getAdminUserDetails: createAction(
    ModuleEvents.GET_ADMIN_STUDENT_LIST,
    async (params) => {
      const data = await AdminStudentRepository.getAdminUsersList(params);
      return { ...data, params };
    }
  ),

  createAdminStudent: createAction(
    ModuleEvents.CREATE_ADMIN_STUDENT,
    async (params) => {
      const data = await AdminStudentRepository.createAdminStudent(params);
      return { ...data, params };
    }
  ),

  createAdminNewStudent: createAction(
    ModuleEvents.CREATE_ADMIN_STUDENT_BY_COURSE,
    async (params) => {
      const data = await AdminStudentRepository.createAdminStudent(params);
      return { ...data, params };
    }
  ),

  updateStudentStatus: createAction(
    ModuleEvents.UPDATE_STUDENT_STATUS,
    async (params) => {
      const data = await AdminStudentRepository.updateStudentStatus(params);
      return { ...data, params };
    }
  ),

  getCourseList: createAction(ModuleEvents.GET_COURSE_LIST, async () => {
    const data = await CommonRepository.courseList();
    return { ...data };
  }),

  getStudentProgress: createAction(
    ModuleEvents.GET_STUDENT_PROGRESS,
    async (params) => {
      const data = await AdminStudentRepository.getStudentProgress(params);
      return { ...data };
    }
  ),

  getStudentAttemptDetails: createAction(
    ModuleEvents.GET_STUDENT_ATTEMPTDETAILS,
    async (params) => {
      const data = await AdminStudentRepository.getStudentAttemptDetails(
        params
      );
      return { ...data };
    }
  ),

  getAdminCourseDetails: createAction(
    ModuleEvents.GET_ADMIN_STUDENT_COURSEDETAILS,
    async (params) => {
      const data = await AdminStudentRepository.getAdminCourseDetails(params);
      return { ...data };
    }
  ),

  getAllAdminUserDetails: createAction(
    ModuleEvents.GET_ALL_ADMIN_STUDENT_LIST,
    async (params) => {
      const data = await AdminStudentRepository.getAdminUsersList(params);
      return { ...data, params };
    }
  ),

  resetCourseProgress: createAction(
    ModuleEvents.RESET_COURSE_PROGRESS,
    async ({ email }) => {
      const data = await AdminStudentRepository.resetCourseProgress(email);
      return { ...data };
    }
  ),

  fetchStudentById: createAction(
    ModuleEvents.FETCH_STUDENT_BY_ID,
    async (id) => {
      const data = await AdminStudentRepository.fetchStudentById(id);
      return { ...data };
    }
  ),

  updateStudent: createAction(
    ModuleEvents.UPDATE_STUDENT,
    async ({ id, ...params }) => {
      const data = await AdminStudentRepository.updateStudent(id, params);
      return { ...data, id };
    }
  ),

  updateStudentEnrollment: createAction(
    ModuleEvents.UPDATE_STUDENT_ENROLLMENT,
    async (params) => {
      const data = await AdminStudentRepository.updateStudentEnrollment(params);
      return { ...data };
    }
  ),

  deleteStudent: createAction(
    ModuleEvents.DELETE_STUDENT_REVIEWS,
    async (id) => {
      const data = await AdminStudentRepository.deleteStudentReview(id);
      return { ...data, id };
    }
  ),
};
